import React from "react";
import PropTypes from 'prop-types';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

export default class ModalConfirm extends React.Component {

    static propTypes = {
        onOkClick: PropTypes.func,
        onCancelClick: PropTypes.func,
        header: PropTypes.string,
        message: PropTypes.string,
        show: PropTypes.bool,
        ok: PropTypes.string,
        cancel: PropTypes.string,
        checkboxLabel: PropTypes.string,
        checkboxChecked: PropTypes.bool,
        onCheckboxChange: PropTypes.func,
    };


    static defaultProps = {
        ok: "OK",
        cancel: "Cancel"
    };

    render() {
        return (
            <Modal isOpen={this.props.show}>
                <ModalHeader toggle={this.props.onCancelClick}>{this.props.header}</ModalHeader>
                <ModalBody>
                    <div style={{whiteSpace: 'pre-line'}}>{this.props.message}</div>
                    {this.props.checkboxLabel &&
                        <label style={{display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px'}}>
                            <input
                                type="checkbox"
                                checked={!!this.props.checkboxChecked}
                                onChange={(e) => {
                                    if (this.props.onCheckboxChange) {
                                        this.props.onCheckboxChange(e.target.checked);
                                    }
                                }}
                            />
                            <span>{this.props.checkboxLabel}</span>
                        </label>}
                </ModalBody>
                <ModalFooter>
                    {this.props.onCancelClick && <Button onClick={this.props.onCancelClick}>{this.props.cancel}</Button>}
                    <Button color="primary" onClick={()=> {
                        this.props.onOkClick();
                        if(this.props.onCancelClick) {
                            this.props.onCancelClick();
                        }
                    }}>{this.props.ok}</Button>
                </ModalFooter>
            </Modal>
        );
    }
}
